import React from 'react';
import { useFeatureFlagContext } from '@fff-web/feature-flags';
import { Disclaimer, DISCLAIMER_NAMES } from '@fff-web/cms';
import { appEnv } from '../../../utils/env';

import styles from './ReactivateDisclaimer.module.scss';

const ReactivateDisclaimer = () => {
  const flags = useFeatureFlagContext();
  const disclaimerName = flags?.disclaimerPriceIncrease
    ? DISCLAIMER_NAMES.reactivateMyMembershipPriceIncrease
    : DISCLAIMER_NAMES.reactivateMyMembership;

  return (
    <div
      className={styles.reactivateDisclaimerContainer}
      data-testid={`${disclaimerName}-disclaimer`}
    >
      <Disclaimer name={disclaimerName} env={appEnv} />
    </div>
  );
};

export default ReactivateDisclaimer;
